import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ForgotPasswordPage = () => {
  const [step, setStep] = useState(1); // 1: Username girme, 2: Başarı mesajı
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
  const [logoMessage, setLogoMessage] = useState('FBAJANS İLE KOLAY E-TİCARET'); // Logo mesajı state'i
  const [logoFile, setLogoFile] = useState(null); // Logo dosyası state'i
  const navigate = useNavigate();

  // Logo mesajını ve dosyasını backend'den çek ve title ayarla
  useEffect(() => {
    // Tarayıcı title'ını ayarla
    document.title = 'FBAJANS WhatsApp Business - Şifre Sıfırlama';
    
    const fetchLogoMessage = async () => {
      try {
        const response = await fetch('/api/admin/settings');
        const data = await response.json();
        if (data.success && data.data.logo_message) {
          setLogoMessage(data.data.logo_message);
        }
        if (data.success && data.data.logo_file) {
          setLogoFile(data.data.logo_file);
        }
      } catch (error) {
        console.error('Logo mesajı çekilemedi:', error);
      }
    };

    fetchLogoMessage();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/auth/forgot_password.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username })
      });

      const data = await response.json();
      
      if (data.status === 'success') {
        setPhoneNumber(data.phone_number);
        setStep(2);
      } else {
        setError(data.message || 'Kullanıcı bulunamadı veya telefon numarası tanımlı değil.');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      setError('Sunucu hatası. Lütfen daha sonra tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center'
      }}>
        {step === 1 ? (
          <>
            {/* Logo & Title */}
            <div style={{ marginBottom: '30px' }}>
              <div style={{ marginBottom: '15px' }}>
                <img 
                  src={logoFile ? `/api/logo/${logoFile}` : "/logo.png"} 
                  alt="Logo" 
                  style={{ 
                    maxHeight: '60px', 
                    width: 'auto'
                  }} 
                />
              </div>
              <h1 style={{
                margin: '0 0 5px',
                color: '#333',
                fontSize: '28px',
                fontWeight: 'bold',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                FBAJANS WhatsApp Business
              </h1>
              <p style={{
                margin: '0 0 5px',
                color: '#666',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Şifre Sıfırlama
              </p>
              <p style={{
                margin: 0,
                color: '#999',
                fontSize: '14px'
              }}>
                Kullanıcı adınızı girin, yeni şifrenizi telefon numaranıza gönderelim
              </p>
            </div>

            {/* Error Message */}
            {error && (
              <div style={{
                background: '#fee',
                color: '#c53030',
                padding: '12px',
                borderRadius: '8px',
                marginBottom: '20px',
                fontSize: '14px',
                border: '1px solid #fed7d7'
              }}>
                <i className="fas fa-exclamation-circle" style={{ marginRight: '8px' }}></i>
                {error}
              </div>
            )}

            {/* Form */}
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '25px' }}>
                <input
                  type="text"
                  placeholder="Kullanıcı Adı (Firma Slug)"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '15px',
                    fontSize: '16px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '10px',
                    outline: 'none',
                    transition: 'border-color 0.3s',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#667eea'}
                  onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '15px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  color: 'white',
                  background: loading ? '#a0aec0' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s',
                  marginBottom: '20px'
                }}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    <i className="fas fa-mobile-alt" style={{ marginRight: '8px' }}></i>
                    Yeni Şifre Gönder
                  </>
                )}
              </button>
            </form>

            <button
              type="button"
              onClick={handleBackToLogin}
              style={{
                background: 'none',
                border: 'none',
                color: '#667eea',
                textDecoration: 'underline',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              ← Giriş Sayfasına Dön
            </button>
          </>
        ) : (
          <>
            {/* Success Message */}
            <div style={{ marginBottom: '30px' }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '10px'
              }}>
                <i className="fas fa-check-circle" style={{ fontSize: '48px', color: '#28a745' }}></i>
              </div>
              <h1 style={{
                margin: 0,
                color: '#333',
                fontSize: '28px',
                fontWeight: 'bold',
                marginBottom: '10px'
              }}>
                Şifre Gönderildi!
              </h1>
              <p style={{
                margin: 0,
                color: '#666',
                fontSize: '16px',
                lineHeight: '1.5'
              }}>
                Yeni şifreniz <strong>{phoneNumber}</strong> numaralı telefona WhatsApp ile gönderildi.
                <br /><br />
                Mesajı aldıktan sonra yeni şifrenizle giriş yapabilirsiniz.
              </p>
            </div>

            <div style={{
              background: '#e6fffa',
              color: '#234e52',
              padding: '15px',
              borderRadius: '10px',
              marginBottom: '25px',
              fontSize: '14px',
              border: '1px solid #b2f5ea'
            }}>
              <i className="fas fa-lightbulb" style={{ marginRight: '8px' }}></i>
              <strong>Not:</strong> Mesajın gelmesi birkaç dakika sürebilir. Spam klasörünüzü de kontrol etmeyi unutmayın.
            </div>

            <button
              type="button"
              onClick={handleBackToLogin}
              style={{
                width: '100%',
                padding: '15px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: 'white',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
            >
              <i className="fas fa-rocket" style={{ marginRight: '8px' }}></i>
              Giriş Sayfasına Dön
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage; 